import { skipToken } from '@reduxjs/toolkit/query'
import { selectAccountId } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'
import { useDownloadGlobalFileRequestQuery } from '../../store/media/file'
import { useGetUserByIdQuery } from '../../store/user/user'
import { getInitials } from '../../views/utils'
import type { UserAvatarProps } from './UserAvatar'

type UseUserAvatarProps = Partial<UserAvatarProps> & { userId?: string }

export const useUserAvatarProps = ({ userId, ...overrides }: UseUserAvatarProps): UserAvatarProps => {
  const accountId = useAppSelector(selectAccountId)
  const { data: user } = useGetUserByIdQuery(userId ? { accountId, userId } : skipToken)
  const fileId = user?.data.settings?.assets?.avatar?.avatarFile?.fileId
  const { data: download } = useDownloadGlobalFileRequestQuery(fileId ? { accountId, fileId } : skipToken)
  const imageUrl = fileId ? download?.data.location : undefined

  return {
    ...(imageUrl ? { imageUrl } : { useInitials: true, initialLetters: getInitials(user?.data.name) }),
    ...overrides,
  }
}
